module.exports = __webpack_public_path__ + "e008adac4ad2ba87a92ea691328587a8.png";